/* StickerSocials customer decal designer for the dedicated Shopify product page. */
(function () {
  'use strict';

  const D = window.SSDecal;
  const Order = window.SSStorefrontOrder;
  const SIZE_CHOICES = [
    { label: 'Standard Decal', width: 230, cm: '23 × 3 cm max' },
    { label: 'Larger Decal', width: 260, maxHeight: 50, cm: '26 × 5 cm max' },
    { label: 'Small Banner', width: 450, cm: '45 cm' },
    { label: 'Medium Banner', width: 550, cm: '55 cm' },
    { label: 'Large Banner', width: 850, cm: '85 cm' },
    { label: 'Custom Size', width: null, cm: 'Your dimensions' },
  ];
  const DISCOUNT_TIERS = [
    { quantity: 2, percent: 20 },
    { quantity: 4, percent: 30, feature: 'Most Popular' },
    { quantity: 10, percent: 40 },
    { quantity: 20, percent: 50 },
    { quantity: 40, percent: 55, feature: 'Best Value' },
    { quantity: 100, percent: 55 },
  ];
  const FREE_SHIPPING_MIN_CENTS = 15001;
  const FREE_SHIPPING_NUDGE_CENTS = 10000;
  // Store product snapshots for the local preview. Recheck Shopify at checkout integration.
  const ADD_ONS = {
    squeegee: { label: 'Applicator Squeegee', image: 'assets/upsell-squeegee.jpg', url: 'https://stickersocials.com.au/products/applicator-squeegee', variants: [{ id: 43877114544316, label: 'Applicator Squeegee', price: 495 }] },
    backing: { label: 'Matte Black Sunstrip Backing', image: 'assets/upsell-sunstrip.jpg', url: 'https://stickersocials.com.au/products/custom-matte-black-sunstrip-banner-sticker', variants: [
      { id: 43181894041788, label: 'Small, 140 × 30 cm', price: 2000 },
      { id: 43181894074556, label: 'Medium, 160 × 30 cm', price: 2500 },
      { id: 43181894107324, label: 'Large, 180 × 30 cm', price: 3000 },
    ] },
  };
  const COLOURS = [
    { label: 'White', material: 'Gloss vinyl', hex: '#ffffff' },
    { label: 'Black', material: 'Gloss vinyl', hex: '#101010' },
    { label: 'Holographic', material: 'Specialty vinyl', stops: [[0, '#ff7dc6'], [0.14, '#c48aff'], [0.28, '#72adff'], [0.42, '#7bfff0'], [0.58, '#d5ffa0'], [0.72, '#ffe782'], [0.86, '#ff9ea4'], [1, '#c692ff']] },
    { label: 'Metallic Silver', shortLabel: 'Silver', material: 'Specialty vinyl', stops: [[0, '#68747e'], [0.13, '#e7eff2'], [0.25, '#8b99a3'], [0.34, '#faffff'], [0.40, '#9aa6ad'], [0.58, '#56636d'], [0.75, '#edf5f7'], [0.89, '#919ba2'], [1, '#d9e1e5']] },
    { label: 'Metallic Gold', shortLabel: 'Gold', material: 'Specialty vinyl', stops: [[0, '#8a5a16'], [0.13, '#e1b54d'], [0.25, '#a96b1a'], [0.34, '#fff2ae'], [0.40, '#cb8f29'], [0.58, '#81501a'], [0.75, '#f8d981'], [0.89, '#b67a24'], [1, '#efc866']] },
    { label: 'Blue', material: 'Gloss vinyl', hex: '#2e8bd6' },
    { label: 'Pink', material: 'Gloss vinyl', hex: '#ff83bc' },
    { label: 'Magenta', material: 'Gloss vinyl', hex: '#d01883' },
    { label: 'Dark Blue', material: 'Gloss vinyl', hex: '#1765d0' },
    { label: 'Red', material: 'Gloss vinyl', hex: '#ff0033' },
  ];
  let gradientSerial = 0;
  // Keep original artwork IDs for existing orders; only hide retired customer choices.
  const RETIRED_FONTS = new Set([19, 20]);
  const RETIRED_ICONS = new Set(['FACEBOOK3', 'TWITCH2', 'SNAPCHAT2', 'SNAPCHAT3', 'SNAPCHAT4', 'INSTAGRAM3', 'YOUTUBE3', 'YOUTUBE4']);
  const FONT_NUMBERS = D.FONTS.filter(font => !RETIRED_FONTS.has(font.n) && Boolean(window.SS_FONTS?.[font.file])).map(font => font.n);
  const iconNumbers = platform => Array.from({ length: platform.count }, (_, index) => index + 1)
    .filter(number => !RETIRED_ICONS.has(D.iconKey(platform.key, number)));
  const money = cents => new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(cents / 100);
  const cmNumber = n => new Intl.NumberFormat('en-AU', { maximumFractionDigits: 2 }).format(n / 10);
  const cm = n => `${cmNumber(n)} cm`;
  const cmInput = n => String(Number((n / 10).toFixed(2)));
  const nextHalfCm = (value, direction) => direction > 0
    ? (Math.floor(value * 2 + 1e-8) + 1) / 2
    : (Math.ceil(value * 2 - 1e-8) - 1) / 2;
  const STEP_MINUS = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4 10h12"/></svg>';
  const STEP_PLUS = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4 10h12M10 4v12"/></svg>';
  const HEADING_ARROW_STYLES = ['Round Arrow', 'Arrow', 'Thick Arrow'];
  const swatchPaint = colour => colour.stops
    ? `linear-gradient(110deg, ${colour.stops.map(([at, hex]) => `${hex} ${at * 100}%`).join(', ')})`
    : colour.hex;

  function option(el, value, label) {
    const o = document.createElement('option');
    o.value = value;
    o.textContent = label;
    el.append(o);
  }

  function variantFor(config, size, material) {
    const product = config.product || {};
    const names = product.options || [];
    const variants = product.variants || [];
    const sizeAt = names.findIndex(n => /^size$/i.test(n));
    const materialAt = names.findIndex(n => /^material$/i.test(n));
    if (sizeAt < 0 && materialAt < 0) {
      return size === 'Standard Decal' && material === 'Gloss vinyl' ? variants[0] : null;
    }
    return variants.find(v => {
      const values = v.options || [v.option1, v.option2, v.option3];
      return (sizeAt < 0 ? size === 'Standard Decal' : values[sizeAt] === size) &&
        (materialAt < 0 ? material === 'Gloss vinyl' : values[materialAt] === material);
    }) || null;
  }

  function mount(root) {
    const configNode = root.querySelector('script[type="application/json"]');
    let config;
    try { config = JSON.parse(configNode.textContent); }
    catch { root.textContent = 'The designer could not load its product settings.'; return; }
    if (!Order) { root.textContent = 'The designer could not load its order settings. Reload the page.'; return; }
    const addOnImages = {
      squeegee: config.addOnImages?.squeegee || ADD_ONS.squeegee.image,
      backing: config.addOnImages?.backing || ADD_ONS.backing.image,
    };
    const headingArrowChoices = HEADING_ARROW_STYLES.map(style => {
      const commands = window.SSHeadingGeometry?.arrowCommands(style);
      if (!commands) return '';
      const bounds = D.bbox(commands);
      const inset = Math.max(bounds.w, bounds.h) * 0.03;
      return `<button type="button" class="ss-heading-arrow-choice" data-ss-heading-arrow-choice="${style}" aria-label="${style}" aria-pressed="false"><svg viewBox="${bounds.x0 - inset} ${bounds.y0 - inset} ${bounds.w + 2 * inset} ${bounds.h + 2 * inset}" aria-hidden="true"><path d="${D.toD(commands)}" fill="currentColor"/></svg><span>${style}</span></button>`;
    }).join('');
    root.innerHTML = `
      <div class="ss-preview-card">
        <div class="ss-preview-head"><span>Your Decal</span><span data-ss-size></span></div>
        <div class="ss-stage" data-ss-stage>
          <div class="ss-assembly" data-ss-assembly>
            <div class="ss-art-row"><div class="ss-ruler-y" data-ss-ruler-y role="img"><span class="ss-ruler-label" data-ss-height-label>...</span></div><div class="ss-art" data-ss-art></div></div>
            <div class="ss-ruler-x" data-ss-ruler-x role="img"><span class="ss-ruler-label" data-ss-width-label>...</span><span class="ss-mobile-size-label" data-ss-mobile-size-label aria-hidden="true">...</span></div>
          </div>
          <span class="ss-zoom-note" data-ss-zoom-note hidden>Zoomed Preview</span>
        </div>
        <p class="ss-preview-warning" data-ss-warning role="alert" hidden></p>
      </div>
      <div class="ss-grid">
        <div class="ss-controls">
          <label class="ss-field">Decal Size<select name="sizeChoice"></select></label>
          <div class="ss-sizing ss-custom-size" data-ss-custom-size hidden><p>Set length or height. The other dimension follows the artwork.</p>
            <div class="ss-pair"><div class="ss-field"><label for="ss-sticker-length">Sticker Length (cm)</label><span class="ss-number-stepper"><button type="button" data-ss-size-axis="width" data-ss-size-step="-1" aria-label="Decrease Sticker Length">${STEP_MINUS}</button><input id="ss-sticker-length" name="widthCm" type="number" min="4" max="150" step="0.5" inputmode="decimal"><button type="button" data-ss-size-axis="width" data-ss-size-step="1" aria-label="Increase Sticker Length">${STEP_PLUS}</button></span></div><div class="ss-field"><label for="ss-sticker-height">Sticker Height (cm)</label><span class="ss-number-stepper"><button type="button" data-ss-size-axis="height" data-ss-size-step="-1" aria-label="Decrease Sticker Height">${STEP_MINUS}</button><input id="ss-sticker-height" name="heightCm" type="number" min="2" max="150" step="0.5" inputmode="decimal"><button type="button" data-ss-size-axis="height" data-ss-size-step="1" aria-label="Increase Sticker Height">${STEP_PLUS}</button></span></div></div>
          </div>
          <div class="ss-handle-heading-row"><label class="ss-field">Your Handle<input name="username" type="text" maxlength="40" autocomplete="off" placeholder="e.g. YourSocials" value="YourSocials"></label><button class="ss-icon-toggle ss-heading-toggle" type="button" data-ss-heading-toggle aria-expanded="false" aria-controls="ss-heading-panel"><span data-ss-heading-button-label>Add Heading</span><small data-ss-heading-button-note>Sets Length To 30 cm</small></button></div>
          <p class="ss-heading-size-note" data-ss-heading-size-note role="status" hidden>Length Set To 30 cm For Your Heading.</p>
          <div class="ss-heading-panel" id="ss-heading-panel" data-ss-heading-panel hidden>
            <div class="ss-second-icon-head"><strong>Above Your Decal</strong><button type="button" data-ss-remove-heading>Remove Heading</button></div>
            <div class="ss-heading-intro"><label class="ss-field">Heading Text<select name="headingPreset"><option value="Follow us on">Follow Us On</option><option value="Check our socials">Check Our Socials</option><option value="Tag us in your story">Tag Us In Your Story</option><option value="Message us to book">Message Us To Book</option><option value="custom">Custom Text</option></select></label><label class="ss-check ss-heading-arrow"><input name="headingArrow" type="checkbox" checked><span>Show Arrow</span></label></div>
            ${document.getElementById('ss-heading-ideas') ? '<a class="ss-heading-ideas-link" href="#ss-heading-ideas">Need Wording Ideas?</a>' : ''}
            <label class="ss-field" data-ss-heading-custom-wrap hidden>Custom Heading<input name="headingCustom" type="text" maxlength="40" autocomplete="off" placeholder="Write your heading" value="Custom Text"></label>
            <div class="ss-heading-basic-grid">
              <div class="ss-field ss-heading-font-field"><span>Heading Font</span><select name="headingFont" hidden aria-hidden="true" tabindex="-1"><option value="match">Match Main Font</option></select><div class="ss-font-picker"><button class="ss-font-trigger" type="button" data-ss-heading-font-trigger aria-label="Choose Heading Font" aria-expanded="false" aria-controls="ss-heading-font-menu"></button><div class="ss-font-menu" id="ss-heading-font-menu" data-ss-heading-font-menu role="group" aria-label="Heading Fonts" hidden></div></div></div>
              <label class="ss-field">Heading Alignment<select name="headingAlign"><option>Left</option><option selected>Centre</option><option>Right</option></select></label>
              <div class="ss-field ss-heading-arrow-style-field"><span>Arrow Style</span><input name="headingArrowStyle" type="hidden" value="Round Arrow"><div class="ss-heading-arrow-choices" role="group" aria-label="Arrow Style">${headingArrowChoices}</div></div>
            </div>
          </div>
          <div data-ss-first-icon-panel><div class="ss-second-icon-head ss-first-icon-head"><strong>Icon</strong><button type="button" data-ss-remove-first-icon>Remove Icon</button></div><div class="ss-icon-section"><label class="ss-field">Platform<select name="platform"></select></label><div class="ss-field"><span>Style</span><select name="icon" hidden aria-hidden="true" tabindex="-1"></select><div class="ss-icon-picker-row"><div class="ss-icon-picker" data-ss-icon-picker role="group" aria-label="Style"></div><button class="ss-icon-toggle ss-add-icon-choice" type="button" data-ss-icon-toggle aria-expanded="false" aria-controls="ss-second-icon-panel"><span class="ss-add-icon-mark" aria-hidden="true">${STEP_PLUS}</span><span>Add Second Icon</span></button></div></div></div></div><button class="ss-icon-toggle ss-restore-icon" type="button" data-ss-add-first-icon hidden><span aria-hidden="true">${STEP_PLUS}</span>Add Icon</button>
          <div class="ss-second-icon-panel" id="ss-second-icon-panel" data-ss-second-icon-panel hidden>
            <div class="ss-second-icon-head"><strong>Second Icon</strong><button type="button" data-ss-remove-icon>Remove Second Icon</button></div>
            <div class="ss-icon-section"><label class="ss-field">Second Platform<select name="secondPlatform"></select></label><div class="ss-field"><span>Second Style</span><select name="secondIcon" hidden aria-hidden="true" tabindex="-1" disabled></select><div class="ss-icon-picker-row"><div class="ss-icon-picker" data-ss-second-icon-picker role="group" aria-label="Second Style"></div><button class="ss-icon-toggle ss-add-icon-choice" type="button" data-ss-third-icon-toggle aria-expanded="false" aria-controls="ss-third-icon-panel"><span class="ss-add-icon-mark" aria-hidden="true">${STEP_PLUS}</span><span>Add Third Icon</span></button></div></div></div>
          </div>
          <div class="ss-second-icon-panel" id="ss-third-icon-panel" data-ss-third-icon-panel hidden>
            <div class="ss-second-icon-head"><strong>Third Icon</strong><button type="button" data-ss-remove-third-icon>Remove Third Icon</button></div>
            <div class="ss-icon-section"><label class="ss-field">Third Platform<select name="thirdPlatform"></select></label><div class="ss-field"><span>Third Style</span><select name="thirdIcon" hidden aria-hidden="true" tabindex="-1" disabled></select><div class="ss-icon-picker" data-ss-third-icon-picker role="group" aria-label="Third Style"></div></div></div>
          </div>
          <div class="ss-pair"><div class="ss-field"><span>Font</span><select name="font" hidden aria-hidden="true" tabindex="-1"></select><div class="ss-font-picker"><button class="ss-font-trigger" type="button" data-ss-font-trigger aria-label="Choose Font" aria-expanded="false" aria-controls="ss-font-menu"></button><div class="ss-font-menu" id="ss-font-menu" data-ss-font-menu role="group" aria-label="Fonts" hidden></div></div></div><div class="ss-adjust ss-icon-size-adjust"><span>Icon Size</span><div class="ss-adjust-stepper"><button type="button" data-ss-icon-size-step="-1" aria-label="Make Icons Smaller">${STEP_MINUS}</button><output data-ss-icon-size-value aria-live="polite">Match Text</output><button type="button" data-ss-icon-size-step="1" aria-label="Make Icons Larger">${STEP_PLUS}</button></div><input name="iconSize" type="hidden" value="0"></div></div>
          <div class="ss-colour-group"><div class="ss-field"><div class="ss-colour-heading"><span>Colour</span><span class="ss-finish-note">On-screen colours and finishes are a guide.</span></div><select name="colour" hidden aria-hidden="true" tabindex="-1"></select><div class="ss-colour-picker" id="ss-colour-picker" data-ss-colour-picker role="group" aria-label="Colour">${COLOURS.map(c => `<button type="button" class="ss-colour-choice" data-ss-colour-choice="${c.label}" aria-label="${c.label}" aria-pressed="false"><span class="ss-colour-sample" style="background:${swatchPaint(c)}" aria-hidden="true"></span><span class="ss-colour-name">${c.label === 'Holographic' ? 'Holo<wbr>graphic' : c.shortLabel || c.label}</span></button>`).join('')}</div><button class="ss-colour-toggle" type="button" data-ss-colour-toggle aria-expanded="false" aria-controls="ss-colour-picker">Show More Colours</button></div></div>
          <button class="ss-icon-toggle ss-advanced-toggle" type="button" data-ss-advanced-toggle aria-expanded="false" aria-controls="ss-advanced-panel">Advanced Settings</button>
          <div class="ss-advanced-panel" id="ss-advanced-panel" data-ss-advanced-panel hidden>
            <div class="ss-advanced-head"><strong>Advanced Settings</strong><span class="ss-advanced-head-actions"><button type="button" data-ss-reset-advanced>Reset</button><button type="button" data-ss-close-advanced>Close</button></span></div>
            <div class="ss-advanced-adjustments">
              <div class="ss-adjust"><span>Spacing</span><div class="ss-adjust-stepper"><button type="button" data-ss-adjust="spacing" data-ss-direction="-1" aria-label="Tighten Spacing">${STEP_MINUS}</button><output data-ss-spacing-value>Default</output><button type="button" data-ss-adjust="spacing" data-ss-direction="1" aria-label="Widen Spacing">${STEP_PLUS}</button></div><input name="spacing" type="hidden" value="0"></div>
              <div class="ss-adjust"><span>Icon Position</span><div class="ss-adjust-stepper"><button type="button" data-ss-adjust="iconPosition" data-ss-direction="-1" aria-label="Move Icon Up"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 16V4M5 9l5-5 5 5"/></svg></button><output data-ss-icon-position-value>Centre</output><button type="button" data-ss-adjust="iconPosition" data-ss-direction="1" aria-label="Move Icon Down"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 4v12M5 11l5 5 5-5"/></svg></button></div><input name="iconPosition" type="hidden" value="0"></div>
            </div>
            <div class="ss-advanced-options"><label class="ss-check"><input name="upper" type="checkbox"><span>Use Capitals</span></label><div class="ss-inverse-option"><label class="ss-check"><input name="inverse" type="checkbox"><span>Inverse Decal</span></label><details class="ss-help"><summary aria-label="About Inverse Decals">?</summary><p>For inside-glass installation. Mirrored so it reads correctly from outside.</p></details></div></div>
            <div class="ss-heading-advanced" data-ss-heading-advanced hidden>
              <strong>Heading Settings</strong>
              <div class="ss-heading-advanced-grid">
                <div class="ss-adjust"><span>Size (cm)</span><div class="ss-adjust-stepper ss-heading-size-stepper"><button type="button" data-ss-heading-size-step="-1" aria-label="Make Heading 0.5 cm Smaller">${STEP_MINUS}</button><input name="headingSizeCm" type="number" min="2" max="57" step="any" inputmode="decimal" aria-label="Heading Size In Centimetres" placeholder="Auto"><button type="button" data-ss-heading-size-step="1" aria-label="Make Heading 0.5 cm Larger">${STEP_PLUS}</button></div><input name="headingSizeStep" type="hidden" value="0"></div>
                <div class="ss-adjust"><span>Line Gap</span><div class="ss-adjust-stepper"><button type="button" data-ss-heading-gap-step="-5" aria-label="Reduce Line Gap">${STEP_MINUS}</button><output data-ss-heading-gap-value>1 cm</output><button type="button" data-ss-heading-gap-step="5" aria-label="Increase Line Gap">${STEP_PLUS}</button></div><input name="headingGap" type="hidden" value="10"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="ss-order">
          <div class="ss-quantity-group">
            <div class="ss-field ss-quantity"><label for="ss-quantity-input">Select Quantity</label><span class="ss-quantity-stepper"><button type="button" data-ss-qty-step="-1" aria-label="Decrease Quantity">${STEP_MINUS}</button><input id="ss-quantity-input" name="qty" type="number" min="1" max="10000" step="1" inputmode="numeric" value="2"><button type="button" data-ss-qty-step="1" aria-label="Increase Quantity">${STEP_PLUS}</button></span></div>
            <div class="ss-quantity-alternative"><span>Bulk Discount</span></div>
            <div class="ss-tiers" role="group" aria-label="Quantity Discounts">${DISCOUNT_TIERS.map(t => `<button type="button" data-ss-tier="${t.quantity}" aria-pressed="false"><span class="ss-tier-top"><strong>${t.quantity}+ Decals</strong>${t.feature ? `<span class="ss-tier-feature">${t.feature}</span>` : ''}</span><span class="ss-tier-deal"><span class="ss-tier-save">${t.percent}% OFF</span><span class="ss-tier-price" data-ss-tier-price>...</span></span></button>`).join('')}</div>
          </div>
          <div class="ss-addons"><strong class="ss-addons-title">Upgrade Your Install <span aria-hidden="true">✨</span></strong>
            <div class="ss-addon-row"><input name="squeegee" type="checkbox" hidden><img src="${addOnImages.squeegee}" alt="" loading="lazy"><span class="ss-addon-copy"><strong>Applicator Squeegee</strong><small>${money(ADD_ONS.squeegee.variants[0].price)} Each</small></span><button class="ss-addon-button" type="button" data-ss-addon-button="squeegee" aria-pressed="false">Add To Cart</button></div>
            <div class="ss-addon-row ss-backing" data-ss-backing hidden><input name="backing" type="checkbox" hidden><img src="${addOnImages.backing}" alt="" loading="lazy"><span class="ss-addon-copy"><strong>Matte Black Sunstrip Backing</strong><span class="ss-addon-price"><span class="ss-addon-discount" data-ss-backing-discount hidden></span><span><strong data-ss-backing-each>${money(ADD_ONS.backing.variants[0].price)}</strong> Each</span><small data-ss-backing-was hidden></small></span></span>
              <div class="ss-addon-actions"><div class="ss-addon-quantity"><span>Quantity</span><output data-ss-backing-qty aria-label="Backing Quantity">2</output></div><label class="ss-field">Size<select name="backingSize"><option value="0">140 × 30 cm</option><option value="1">160 × 30 cm</option><option value="2">180 × 30 cm</option></select></label><button class="ss-addon-button" type="button" data-ss-addon-button="backing" aria-pressed="false">Add To Cart</button></div>
            </div>
          </div>
          <div class="ss-total"><span>Decal Total</span><strong data-ss-price>...</strong></div>
          <p class="ss-discount"><span data-ss-price-detail>Price updates as you design.</span><span class="ss-savings" data-ss-savings hidden></span></p>
          <div class="ss-shipping-prompt" data-ss-shipping-prompt data-state="close" role="status" aria-live="polite" hidden><strong>📦 FREE Tracked Shipping</strong><span data-ss-shipping-detail></span><small>Final discounts and delivery confirmed at checkout.</small><span class="ss-shipping-progress" aria-hidden="true"><span data-ss-shipping-progress></span></span></div>
          <div class="ss-cart-actions"><button class="ss-add button button--primary" type="button" data-ss-purchase="cart" disabled>Add To Cart</button><button class="ss-checkout button button--primary" type="button" data-ss-purchase="checkout" disabled>Checkout</button><div class="ss-cart-toast" data-ss-cart-toast role="status" aria-live="polite" hidden></div></div>
          <p class="ss-cart-message" data-ss-cart-message role="status"></p>
        </div>
      </div>`;

    const field = name => root.querySelector(`[name="${name}"]`);
    const out = name => root.querySelector(`[data-ss-${name}]`);
    function updateFreeShipping() {
      const prompt = out('shipping-prompt');
      const isAustralian = String(config.countryCode || '').toUpperCase() === 'AU' &&
        String(config.currencyCode || '').toUpperCase() === 'AUD';
      const cents = cartTotalCents;
      prompt.hidden = !isAustralian || !Number.isSafeInteger(cents) || cents <= FREE_SHIPPING_NUDGE_CENTS;
      if (prompt.hidden) return;
      const reached = cents >= FREE_SHIPPING_MIN_CENTS;
      prompt.dataset.state = reached ? 'reached' : 'close';
      out('shipping-detail').textContent = reached
        ? 'Your cart has unlocked free tracked shipping. Choose Standard at checkout.'
        : `Your cart is only ${money(FREE_SHIPPING_MIN_CENTS - cents)} from unlocking free tracked shipping.`;
      out('shipping-progress').style.width = `${Math.min(100, cents / FREE_SHIPPING_MIN_CENTS * 100)}%`;
    }
    function updateColourToggle() {
      const expanded = root.dataset.ssColoursExpanded === 'true';
      const selected = field('colour').value;
      const hiddenSelection = !expanded && COLOURS.findIndex(c => c.label === selected) >= 5;
      out('colour-toggle').setAttribute('aria-expanded', String(expanded));
      out('colour-toggle').textContent = expanded ? 'Show Fewer Colours'
        : hiddenSelection ? `Show More Colours (${selected} Selected)` : 'Show More Colours';
    }
    function showWarning(message) {
      const bubble = out('warning');
      bubble.textContent = message;
      bubble.hidden = !message;
    }
    function designError(message) {
      if (/Unknown size/i.test(message)) return 'Choose a decal size.';
      if (/Username is empty/i.test(message)) return 'Enter your handle.';
      if (/Username is too long/i.test(message)) return 'Handle is too long. Max 40 characters.';
      if (/This font cannot render/i.test(message)) return 'This font cannot show your handle. Choose another font.';
      if (/Font .* is not loaded/i.test(message)) return 'This font is unavailable. Choose another font.';
      if (/platform and icon style/i.test(message)) return 'Choose a platform and icon.';
      if (/No icon|no usable cutting outline/i.test(message)) return 'This icon cannot be cut. Choose another.';
      if (/no visible cutting paths/i.test(message)) return 'This handle cannot be cut with this font.';
      if (/does not fit inside this template/i.test(message)) return 'This design does not fit. Choose a larger size.';
      if (/Could not merge the cutting paths/i.test(message)) return 'This design could not be prepared. Try another font or icon.';
      if (/advanced setting/i.test(message)) return 'Choose an available advanced setting.';
      if (/heading/i.test(message)) return message;
      return 'Preview unavailable. Reload the page.';
    }
    for (const p of D.PLATFORMS) option(field('platform'), p.key, p.label);
    for (const name of ['secondPlatform', 'thirdPlatform']) {
      option(field(name), '', 'Choose A Platform');
      for (const p of D.PLATFORMS) option(field(name), p.key, p.label);
    }
    for (const choice of SIZE_CHOICES) option(field('sizeChoice'), choice.label, choice.width ? `${choice.label} (${choice.cm})` : choice.label);
    for (const n of FONT_NUMBERS) option(field('font'), String(n), `Font ${n}`);
    for (const n of FONT_NUMBERS) option(field('headingFont'), String(n), `Font ${n}`);
    for (const c of COLOURS) option(field('colour'), c.label, c.label);
    field('font').value = '2';
    field('colour').value = 'White';

    const svgNS = 'http://www.w3.org/2000/svg';
    function iconSample(platform, number) {
      const commands = window.SS_CUSTOM_ICONS?.[D.iconKey(platform, number)];
      if (!commands) return null;
      const box = D.bbox(commands);
      if (!Number.isFinite(box.w) || !Number.isFinite(box.h) || box.w <= 0 || box.h <= 0) return null;
      const size = Math.max(box.w, box.h);
      const padding = size * 0.06;
      const side = size + 2 * padding;
      const svg = document.createElementNS(svgNS, 'svg');
      svg.setAttribute('viewBox', `${box.x0 + (box.w - size) / 2 - padding} ${box.y0 + (box.h - size) / 2 - padding} ${side} ${side}`);
      svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      svg.setAttribute('aria-hidden', 'true');
      const path = document.createElementNS(svgNS, 'path');
      path.setAttribute('d', D.toD(commands));
      path.setAttribute('fill', '#171717');
      svg.append(path);
      return svg;
    }

    function renderIconPicker(platformName, iconName) {
      const picker = out(iconName === 'icon' ? 'icon-picker' : iconName === 'secondIcon' ? 'second-icon-picker' : 'third-icon-picker');
      const platform = D.PLATFORMS.find(p => p.key === field(platformName).value);
      picker.replaceChildren();
      if (!platform) {
        const hint = document.createElement('span');
        hint.className = 'ss-icon-picker-placeholder';
        hint.textContent = 'Choose a platform to see icons';
        picker.append(hint);
        return;
      }
      for (const i of iconNumbers(platform)) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ss-icon-choice';
        button.dataset.ssIconChoice = String(i);
        button.dataset.ssIconTarget = iconName;
        button.setAttribute('aria-label', `Icon ${i}`);
        button.setAttribute('aria-pressed', String(field(iconName).value === String(i)));
        const art = iconSample(platform.key, i);
        if (art) button.append(art);
        const caption = document.createElement('span');
        caption.textContent = `Icon ${i}`;
        button.append(caption);
        picker.append(button);
      }
    }

    const fontSamples = new Map();
    function fontSample(number) {
      if (fontSamples.has(number)) return fontSamples.get(number).cloneNode(true);
      const font = D.getFont(number);
      const title = `Font ${number}`;
      const sample = [...title].every(char => char === ' ' || font.charToGlyphIndex(char) !== 0) ? title : title.toUpperCase();
      const path = font.getPath(sample, 0, 0, 46, { kerning: true });
      const box = path.getBoundingBox();
      const width = Math.max(1, box.x2 - box.x1);
      const height = Math.max(1, box.y2 - box.y1);
      const padding = 3;
      const svg = document.createElementNS(svgNS, 'svg');
      svg.setAttribute('viewBox', `${box.x1 - padding} ${box.y1 - padding} ${width + padding * 2} ${height + padding * 2}`);
      svg.setAttribute('preserveAspectRatio', 'xMinYMid meet');
      svg.setAttribute('aria-hidden', 'true');
      const outline = document.createElementNS(svgNS, 'path');
      outline.setAttribute('d', path.toPathData(2));
      outline.setAttribute('fill', 'currentColor');
      svg.append(outline);
      fontSamples.set(number, svg);
      return svg.cloneNode(true);
    }

    for (const number of FONT_NUMBERS) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ss-font-choice';
      button.dataset.ssFontChoice = String(number);
      button.setAttribute('aria-label', `Font ${number}`);
      button.append(fontSample(number));
      out('font-menu').append(button);
      const headingButton = button.cloneNode(true);
      delete headingButton.dataset.ssFontChoice;
      headingButton.dataset.ssHeadingFontChoice = String(number);
      out('heading-font-menu').append(headingButton);
    }
    const matchFontButton = document.createElement('button');
    matchFontButton.type = 'button';
    matchFontButton.className = 'ss-font-choice';
    matchFontButton.dataset.ssHeadingFontChoice = 'match';
    matchFontButton.textContent = 'Match Main Font';
    out('heading-font-menu').prepend(matchFontButton);

    function syncFontPicker() {
      const number = Number(field('font').value);
      out('font-trigger').replaceChildren(fontSample(number));
      out('font-trigger').setAttribute('aria-label', `Font ${number}. Choose Font`);
      for (const button of out('font-menu').querySelectorAll('[data-ss-font-choice]')) {
        button.setAttribute('aria-pressed', String(button.dataset.ssFontChoice === String(number)));
      }
    }

    function setFontMenuOpen(open) {
      out('font-menu').hidden = !open;
      out('font-trigger').setAttribute('aria-expanded', String(open));
    }
    function syncHeadingFontPicker() {
      const choice = field('headingFont').value;
      const number = choice === 'match' ? Number(field('font').value) : Number(choice);
      const trigger = out('heading-font-trigger');
      trigger.replaceChildren(fontSample(number));
      trigger.setAttribute('aria-label', choice === 'match' ? `Match Main Font, currently Font ${number}. Choose Heading Font` : `Font ${number}. Choose Heading Font`);
      for (const button of out('heading-font-menu').querySelectorAll('[data-ss-heading-font-choice]')) {
        button.setAttribute('aria-pressed', String(button.dataset.ssHeadingFontChoice === choice));
      }
    }
    function setHeadingFontMenuOpen(open) {
      out('heading-font-menu').hidden = !open;
      out('heading-font-trigger').setAttribute('aria-expanded', String(open));
    }

    function renderIcons(platformName, iconName) {
      const p = D.PLATFORMS.find(x => x.key === field(platformName).value);
      const select = field(iconName);
      const previous = select.value;
      select.replaceChildren();
      if (!p) {
        option(select, '', 'Choose A Platform First');
        select.disabled = true;
        renderIconPicker(platformName, iconName);
        return;
      }
      select.disabled = false;
      const available = iconNumbers(p);
      for (const i of available) option(select, String(i), `Icon ${i}`);
      select.value = available.includes(Number(previous)) ? previous : String(available[0]);
      renderIconPicker(platformName, iconName);
    }

    function updateSecondIconButton() {
      const secondOpen = !out('second-icon-panel').hidden;
      const thirdOpen = !out('third-icon-panel').hidden;
      out('icon-toggle').setAttribute('aria-expanded', String(secondOpen));
      out('icon-toggle').hidden = secondOpen;
      out('third-icon-toggle').setAttribute('aria-expanded', String(thirdOpen));
      out('third-icon-toggle').hidden = !secondOpen || thirdOpen;
    }

    let timer;
    let current = null;
    let adding = false;
    let addedSignature = '';
    let addCooldownUntil = 0;
    let cartToastTimer;
    let squeegeeInCart = false;
    let squeegeeCartReady = false;
    let cartTotalCents = null;
    let previewDimensions = null;
    let selectedSize = SIZE_CHOICES[0].label;
    let sizingMode = 'width';
    let focusedSizeValue = null;
    let headingAutoSized = false;
    let noIcon = false;
    let sizeNotice = '';
    let minimumDimensions = { widthMm: 40, heightMm: 20 };
    let headingSizeRatio = null;
    let lastHeadingHeightMm = null;
    let lastMainWidthMm = null;
    const geometryCache = new Map();
    function resetHeadingControls() {
      out('heading-panel').hidden = true;
      out('heading-toggle').setAttribute('aria-expanded', 'false');
      field('headingPreset').value = 'Follow us on';
      field('headingCustom').value = 'Custom Text';
      field('headingFont').value = 'match';
      field('headingAlign').value = 'Centre';
      field('headingArrow').checked = true;
      field('headingArrowStyle').value = 'Round Arrow';
      field('headingGap').value = '10';
      field('headingSizeCm').value = '';
      field('headingSizeStep').value = '0';
      headingSizeRatio = null;
      lastHeadingHeightMm = null;
      lastMainWidthMm = null;
      headingAutoSized = false;
      current = null;
      setHeadingFontMenuOpen(false);
    }
    function buildArtwork(item, options) {
      // Quantity, vinyl colour, custom scaling and add-ons do not alter the cutting paths.
      const { qty, ...artwork } = item;
      const key = JSON.stringify({ artwork, options });
      if (geometryCache.has(key)) return geometryCache.get(key);
      const result = D.build(item, options);
      if (result.ok) {
        geometryCache.set(key, result);
        if (geometryCache.size > 14) geometryCache.delete(geometryCache.keys().next().value);
      }
      return result;
    }

    function syncAdvancedAdjustments() {
      const settings = [
        { name: 'spacing', min: 0, max: 5, step: 1, output: 'spacing-value', format: value => value === 0 ? 'Default' : `Wider ${value}` },
        { name: 'iconPosition', min: -3, max: 3, step: 0.5, output: 'icon-position-value', format: value => value === 0 ? 'Centre' : value > 0 ? `Down ${value}` : `Up ${-value}` },
      ];
      for (const setting of settings) {
        const value = Number(field(setting.name).value);
        out(setting.output).textContent = setting.format(value);
        for (const button of root.querySelectorAll(`[data-ss-adjust="${setting.name}"]`)) {
          button.disabled = Number(button.dataset.ssDirection) < 0 ? value <= setting.min : value >= setting.max;
        }
      }
      const adjusted = field('upper').checked || field('inverse').checked || Number(field('spacing').value) !== 0 || Number(field('iconPosition').value) !== 0
        || (!out('heading-panel').hidden && (field('headingSizeCm').value !== '' || Number(field('headingGap').value) !== 10));
      out('advanced-toggle').textContent = adjusted ? 'Advanced Settings (Adjusted)' : 'Advanced Settings';
      out('heading-advanced').hidden = out('heading-panel').hidden;
      const headingCm = Number(field('headingSizeCm').value);
      for (const button of root.querySelectorAll('[data-ss-heading-size-step]'))
        button.disabled = field('headingSizeCm').value !== '' && (Number(button.dataset.ssHeadingSizeStep) < 0 ? headingCm <= 2 : headingCm >= 57);
      const headingGapMm = Number(field('headingGap').value);
      out('heading-gap-value').textContent = `${headingGapMm / 10} cm`;
      for (const button of root.querySelectorAll('[data-ss-heading-gap-step]')) {
        button.disabled = Number(button.dataset.ssHeadingGapStep) < 0 ? headingGapMm <= 5 : headingGapMm >= 15;
      }
    }

    function syncIconSizeAdjustment() {
      const step = Number(field('iconSize').value);
      out('icon-size-value').textContent = step === 0 ? 'Match Text' : step < 0 ? `Smaller ${-step}` : `Larger ${step}`;
      for (const button of root.querySelectorAll('[data-ss-icon-size-step]')) {
        button.disabled = Number(button.dataset.ssIconSizeStep) < 0 ? step <= -3 : step >= 3;
      }
    }

    function showCartToast(quantity) {
      const toast = out('cart-toast');
      clearTimeout(cartToastTimer);
      toast.textContent = `${quantity} ${quantity === 1 ? 'Decal' : 'Decals'} Added To Cart`;
      toast.hidden = false;
      cartToastTimer = setTimeout(() => { toast.hidden = true; }, 3500);
    }

    function syncPurchaseButtons() {
      for (const button of root.querySelectorAll('[data-ss-purchase]')) {
        button.disabled = !current || adding || (button.dataset.ssPurchase === 'cart' && Date.now() < addCooldownUntil);
      }
    }

    function discountFor(qty) {
      return [...DISCOUNT_TIERS].reverse().find(t => qty >= t.quantity)?.percent || 0;
    }

    function eligibleBundleQuantity(qty) {
      return qty * (field('backing').checked && !out('backing').hidden ? 2 : 1);
    }

    function renderTier(qty) {
      const tier = [...DISCOUNT_TIERS].reverse().find(t => qty >= t.quantity);
      for (const button of root.querySelectorAll('[data-ss-tier]')) {
        button.setAttribute('aria-pressed', String(Number(button.dataset.ssTier) === tier?.quantity));
      }
    }

    function renderTierPrices(unitListPrice) {
      const unitCents = Math.round(unitListPrice * 100);
      for (const button of root.querySelectorAll('[data-ss-tier]')) {
        const tier = DISCOUNT_TIERS.find(item => item.quantity === Number(button.dataset.ssTier));
        const percent = discountFor(eligibleBundleQuantity(tier.quantity));
        const discountedUnitCents = Math.round(unitCents * (100 - percent) / 100);
        button.querySelector('.ss-tier-save').textContent = `${percent}% OFF`;
        button.querySelector('[data-ss-tier-price]').textContent = `${money(discountedUnitCents)} ea`;
      }
    }

    function sizePreview() {
      if (!previewDimensions) return;
      const { width, height } = previewDimensions;
      const stage = out('stage');
      const stageStyle = getComputedStyle(stage);
      const mobile = matchMedia('(max-width: 760px)').matches;
      const guideAllowance = mobile ? 0 : 116;
      const available = stage.clientWidth - parseFloat(stageStyle.paddingLeft) - parseFloat(stageStyle.paddingRight) - guideAllowance;
      const narrow = stage.clientWidth < 600;
      const referenceWidth = narrow ? 350 : 470;
      const maxHeight = Math.min(stage.clientHeight - parseFloat(stageStyle.paddingTop) - parseFloat(stageStyle.paddingBottom), stage.clientHeight - 64);
      const naturalWidth = available * width / referenceWidth;
      const minimumWidth = available * (mobile ? 1 : 0.95);
      const displayWidth = Math.max(1, Math.min(available, Math.max(naturalWidth, minimumWidth), maxHeight * width / height));
      const displayHeight = displayWidth * height / width;
      out('zoom-note').hidden = displayWidth <= naturalWidth + 1;
      out('assembly').style.width = `${displayWidth}px`;
      out('art').style.width = `${displayWidth}px`;
      out('art').style.height = `${displayHeight}px`;
      out('ruler-y').style.height = `${displayHeight}px`;
      out('ruler-x').style.width = `${displayWidth}px`;
    }

    function artworkSvg(result, stickerWidthMm, stickerHeightMm, productionWidthMm, scale, colour, inverse, paddingXmm, paddingYmm) {
      const ns = 'http://www.w3.org/2000/svg';
      const svg = document.createElementNS(ns, 'svg');
      svg.setAttribute('viewBox', `${paddingXmm * D.MM} ${paddingYmm * D.MM} ${stickerWidthMm * D.MM} ${stickerHeightMm * D.MM}`);
      svg.setAttribute('width', '100%');
      svg.setAttribute('height', '100%');
      svg.setAttribute('role', 'img');
      svg.setAttribute('aria-label', `Decal ${cm(stickerWidthMm)} long by ${cm(stickerHeightMm)} high`);
      const path = document.createElementNS(ns, 'path');
      path.setAttribute('d', result.artD);
      if (colour.stops) {
        const defs = document.createElementNS(ns, 'defs');
        const gradient = document.createElementNS(ns, 'linearGradient');
        const gradientId = `ss-vinyl-finish-${++gradientSerial}`;
        for (const [key, value] of Object.entries({ id: gradientId, x1: '0%', y1: '100%', x2: '100%', y2: '0%' })) gradient.setAttribute(key, value);
        for (const [at, hex] of colour.stops) {
          const stop = document.createElementNS(ns, 'stop');
          stop.setAttribute('offset', `${at * 100}%`);
          stop.setAttribute('stop-color', hex);
          gradient.append(stop);
        }
        defs.append(gradient);
        svg.prepend(defs);
        path.setAttribute('fill', `url(#${gradientId})`);
      } else path.setAttribute('fill', colour.hex);
      path.setAttribute('fill-rule', 'nonzero');
      const offsetX = paddingXmm * D.MM * (1 - scale);
      const offsetY = paddingYmm * D.MM * (1 - scale);
      path.setAttribute('transform', `translate(${offsetX} ${offsetY}) scale(${scale})`);
      if (inverse) {
        const mirror = document.createElementNS(ns, 'g');
        mirror.setAttribute('transform', `translate(${productionWidthMm * D.MM} 0) scale(-1 1)`);
        mirror.append(path);
        svg.append(mirror);
      } else svg.append(path);
      return svg;
    }

    function headedArtwork(base, scale, heading, paddingXmm, paddingYmm) {
      const composed = window.SSHeadingGeometry?.compose({
        mainCommands: base.sourceCommands,
        mainTextHeightMm: base.textHeightMM,
        scale, text: heading.text, font: D.fontForText(heading.font, heading.text),
        sizeStep: heading.sizeStep, sizeMm: heading.sizeMm, sizeRatio: heading.sizeRatio, arrow: heading.arrow,
        arrowStyle: heading.arrowStyle, align: heading.align, gapMm: heading.gapMm,
      }, D);
      if (!composed?.ok) return composed || { ok: false, error: 'Heading preview is unavailable. Reload the page.' };
      const commands = D.transform(composed.commands, 1, 1,
        paddingXmm * D.MM - composed.bounds.x0, paddingYmm * D.MM - composed.bounds.y0);
      let artD;
      try { artD = D.unite(D.toD(commands)); }
      catch (error) { return { ok: false, error: error.message }; }
      return { ...composed, artD, artworkWidthMm: composed.widthMm,
        artworkHeightMm: composed.heightMm, textHeightMM: base.textHeightMM * scale,
        iconHeightMm: base.iconHeightMm * scale,
        mainArtworkWidthMm: base.artworkWidthMm * scale,
        mainArtworkHeightMm: base.artworkHeightMm * scale };
    }

    new ResizeObserver(sizePreview).observe(out('stage'));
    function syncAddOnButtons() {
      for (const kind of ['squeegee', 'backing']) {
        const button = root.querySelector(`[data-ss-addon-button="${kind}"]`);
        const selected = field(kind).checked;
        const checkingCart = kind === 'squeegee' && !squeegeeCartReady;
        const alreadyInCart = kind === 'squeegee' && squeegeeInCart;
        button.disabled = checkingCart || alreadyInCart;
        button.setAttribute('aria-pressed', String(selected));
        button.textContent = checkingCart ? 'Checking Cart' : alreadyInCart ? 'In Cart' : selected ? 'Remove' : 'Add To Cart';
        button.setAttribute('aria-label', alreadyInCart ? 'Applicator Squeegee In Cart' : `${selected ? 'Remove' : 'Add'} ${kind === 'squeegee' ? 'Applicator Squeegee' : 'Matte Black Sunstrip Backing'}${selected ? '' : ' To Cart'}`);
      }
    }
    async function checkSqueegeeInCart() {
      const route = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      try {
        const response = await fetch(route + 'cart.js');
        if (response.ok) {
          const cart = await response.json();
          updateCartState(cart);
        } else cartTotalCents = null;
      } catch (_) {
        // An unavailable cart check must not stop the decal builder loading.
        cartTotalCents = null;
      } finally {
        squeegeeCartReady = true;
        render();
      }
    }
    function updateCartState(cart) {
      if (!Array.isArray(cart?.items)) return false;
      const total = Number(cart.total_price);
      cartTotalCents = Number.isSafeInteger(total) && total >= 0 &&
        (!cart.currency || String(cart.currency).toUpperCase() === 'AUD') ? total : null;
      squeegeeInCart = cart.items.some(line => Number(line.variant_id || line.id) === ADD_ONS.squeegee.variants[0].id);
      if (squeegeeInCart) field('squeegee').checked = false;
      squeegeeCartReady = true;
      return true;
    }
    document.addEventListener('cart:updated', event => {
      if (updateCartState(event.detail?.cart)) render();
      else checkSqueegeeInCart();
    });
    function updateAddOns(size, widthMm, heightMm, qty) {
      const banner = size.label.endsWith('Banner');
      const eligible = banner && widthMm < 1000 - 0.001 && heightMm < 200 - 0.001;
      out('backing').hidden = !eligible;
      if (!eligible) field('backing').checked = false;
      const variant = ADD_ONS.backing.variants[Number(field('backingSize').value)] || ADD_ONS.backing.variants[0];
      const validQty = Number.isInteger(qty) && qty >= 1 && qty <= 10000;
      const discountPercent = validQty ? discountFor(eligibleBundleQuantity(qty)) : 0;
      const backingLineCents = validQty ? Math.round(variant.price * (100 - discountPercent) / 100) * qty : null;
      out('backing-qty').textContent = validQty ? String(qty) : '...';
      out('backing-each').textContent = validQty ? money(backingLineCents / qty) : '...';
      out('backing-discount').hidden = !discountPercent;
      out('backing-discount').textContent = discountPercent ? `${discountPercent}% Off` : '';
      out('backing-was').hidden = !discountPercent;
      out('backing-was').textContent = discountPercent ? `Was ${money(variant.price)} Each` : '';
      const selected = [];
      if (field('squeegee').checked) selected.push({ ...ADD_ONS.squeegee.variants[0], quantity: 1, estimatedLineCents: ADD_ONS.squeegee.variants[0].price });
      if (eligible && field('backing').checked && validQty) selected.push({ ...variant, quantity: qty, estimatedLineCents: backingLineCents });
      syncAddOnButtons();
      return selected;
    }
    function showPrice(baseCents, listCents, detail) {
      const savingsCents = Math.max(0, listCents - baseCents);
      out('price').textContent = money(baseCents);
      out('savings').hidden = savingsCents === 0;
      out('savings').textContent = savingsCents ? `You Save ${money(savingsCents)}` : '';
      out('price-detail').textContent = detail;
      updateFreeShipping();
    }
    function render(commitSizeInput = false) {
      syncFontPicker();
      syncHeadingFontPicker();
      syncAdvancedAdjustments();
      syncIconSizeAdjustment();
      for (const name of ['icon', 'secondIcon', 'thirdIcon']) {
        for (const button of out(name === 'icon' ? 'icon-picker' : name === 'secondIcon' ? 'second-icon-picker' : 'third-icon-picker').querySelectorAll('[data-ss-icon-choice]')) {
          button.setAttribute('aria-pressed', String(button.dataset.ssIconChoice === field(name).value));
        }
      }
      for (const button of out('colour-picker').querySelectorAll('[data-ss-colour-choice]')) {
        button.setAttribute('aria-pressed', String(button.dataset.ssColourChoice === field('colour').value));
      }
      updateColourToggle();
      for (const button of root.querySelectorAll('[data-ss-heading-arrow-choice]')) {
        button.setAttribute('aria-pressed', String(button.dataset.ssHeadingArrowChoice === field('headingArrowStyle').value));
        button.disabled = !field('headingArrow').checked;
      }
      const qty = Number(field('qty').value);
      selectedSize = field('sizeChoice').value;
      const size = SIZE_CHOICES.find(choice => choice.label === selectedSize);
      const standard = selectedSize === 'Standard Decal';
      const largerDecal = selectedSize === 'Larger Decal';
      const productionPaddingXmm = standard || largerDecal ? 2.5 : 5;
      const productionPaddingYmm = 5;
      const custom = size.width === null;
      out('custom-size').hidden = !custom;
      const headingEnabled = !out('heading-panel').hidden;
      if (headingEnabled && size.width !== null && size.width < 300) {
        resetHeadingControls();
        render();
        return;
      }
      out('heading-toggle').setAttribute('aria-expanded', String(headingEnabled));
      out('heading-button-label').textContent = headingEnabled ? 'Heading Added' : 'Add Heading';
      out('heading-button-note').hidden = headingEnabled || (custom ? Number(field('widthCm').value) >= 30 : size.width >= 300);
      out('heading-size-note').hidden = !headingEnabled || !headingAutoSized;
      out('heading-toggle').disabled = false;
      const headingPreset = field('headingPreset').value;
      out('heading-custom-wrap').hidden = !headingEnabled || headingPreset !== 'custom';
      for (const choice of SIZE_CHOICES) {
        const sizeOption = [...field('sizeChoice').options].find(o => o.value === choice.label);
        if (!sizeOption || !choice.width) continue;
        sizeOption.textContent = headingEnabled && choice.label === 'Standard Decal' ? 'Standard Decal (23 cm long)' :
          headingEnabled && choice.label === 'Larger Decal' ? 'Larger Decal (26 cm long)' : `${choice.label} (${choice.cm})`;
      }
      renderTier(qty);
      const item = {
        username: field('username').value,
        noIcon,
        platform: field('platform').value,
        icon: Number(field('icon').value),
        secondPlatform: field('secondPlatform').value,
        secondIcon: field('secondPlatform').value ? Number(field('secondIcon').value) : null,
        thirdPlatform: field('thirdPlatform').value,
        thirdIcon: field('thirdPlatform').value ? Number(field('thirdIcon').value) : null,
        font: Number(field('font').value),
        size: 'M',
        iconSizeStep: Number(field('iconSize').value),
        upper: field('upper').checked,
        inverse: field('inverse').checked,
        spacingStep: Number(field('spacing').value),
        iconYOffsetMm: Number(field('iconPosition').value),
        qty,
      };
      if (headingEnabled) item.heading = {
        text: headingPreset === 'custom' ? field('headingCustom').value : headingPreset,
        font: field('headingFont').value === 'match' ? item.font : Number(field('headingFont').value),
        fontChoice: field('headingFont').value,
        sizeStep: 0,
        sizeMm: null,
        sizeRatio: headingSizeRatio,
        align: field('headingAlign').value,
        arrow: field('headingArrow').checked,
        arrowStyle: field('headingArrowStyle').value,
        gapMm: Number(field('headingGap').value),
      };
      const colour = COLOURS.find(c => c.label === field('colour').value);
      const material = colour.material;
      const hasSecondIcon = Boolean(item.secondPlatform);
      const iconCount = Number(!noIcon) + Number(hasSecondIcon) + Number(Boolean(item.thirdPlatform));
      const selectedHeadingFont = headingEnabled ? D.fontForText(item.heading.font, item.heading.text) : null;
      const inputProblem = Array.from(item.username).length > 40 ? 'Handle is too long. Max 40 characters.'
        : /[^\x20-\x7E]/.test(item.username) ? 'Emojis and special characters are not supported.'
        : headingEnabled && !item.heading.text.trim() ? 'Enter heading text.'
        : headingEnabled && [...item.heading.text].length > 40 ? 'Heading is too long. Max 40 characters.'
        : headingEnabled && /[^\x20-\x7E]/.test(item.heading.text) ? 'Emojis and special characters are not supported.'
        : headingEnabled && !selectedHeadingFont ? 'This heading font is unavailable. Choose another font.'
        : headingEnabled && [...item.heading.text].some(char => char !== ' ' && selectedHeadingFont.charToGlyphIndex(char) === 0) ? 'This font cannot show your heading. Choose another font.' : '';
      let result;
      try { result = inputProblem ? null : buildArtwork(item, { productionPaddingXmm, productionPaddingYmm }); }
      catch (error) { result = { ok: false, error: error.message }; }
      current = null;
      previewDimensions = null;
      out('art').replaceChildren();
      out('assembly').hidden = true;
      out('zoom-note').hidden = true;
      out('size').textContent = '';
      out('width-label').textContent = '...';
      out('height-label').textContent = '...';
      out('mobile-size-label').textContent = '...';
      showWarning('');
      for (const button of root.querySelectorAll('[data-ss-purchase]')) button.disabled = true;
      out('price').textContent = '...';
      out('savings').hidden = true;
      out('savings').textContent = '';
      out('price-detail').textContent = '';
      updateFreeShipping();
      for (const button of root.querySelectorAll('[data-ss-tier-price]')) button.textContent = '...';
      if (inputProblem) { showWarning(inputProblem); return; }
      if (!result.ok) { showWarning(designError(result.error)); return; }
      const requestedAxis = sizingMode === 'height' ? 'height' : 'width';
      const requestedLabel = requestedAxis === 'width' ? 'length' : 'height';
      const requestedValue = custom ? field(`${requestedAxis}Cm`).value : '';
      let requestedCm = custom ? Number(requestedValue) : null;
      if (custom) {
        if (requestedValue === '' || !Number.isFinite(requestedCm)) { showWarning(`Enter a sticker ${requestedLabel}.`); return; }
        if (requestedCm > 150) { showWarning(`Selected ${requestedLabel} is too big. Max 150 cm.`); return; }
      }
      function headingAt(artwork, candidateScale) {
        return window.SSHeadingGeometry?.compose({
          mainCommands: artwork.sourceCommands, mainTextHeightMm: artwork.textHeightMM,
          scale: candidateScale, text: item.heading.text, font: D.fontForText(item.heading.font, item.heading.text),
          sizeStep: item.heading.sizeStep, sizeMm: item.heading.sizeMm, sizeRatio: item.heading.sizeRatio, arrow: item.heading.arrow,
          arrowStyle: item.heading.arrowStyle, align: item.heading.align,
          gapMm: item.heading.gapMm,
        }, D);
      }
      const fitCache = new Map();
      const fitFor = artwork => {
        if (!fitCache.has(artwork)) fitCache.set(artwork, D.fitSize(artwork, {
          axis: requestedAxis, targetMm: requestedCm * 10,
          headingAt: headingEnabled ? candidateScale => headingAt(artwork, candidateScale) : null,
        }));
        return fitCache.get(artwork);
      };
      const scaleFor = artwork => custom ? fitFor(artwork).scale
        : standard ? 1 : Math.min(size.width / artwork.artworkWidthMm,
          size.maxHeight && !headingEnabled ? size.maxHeight / artwork.artworkHeightMm : Infinity);
      function candidateFor(step) {
        if (item.iconSizeStep === step) return result;
        try { return buildArtwork({ ...item, iconSizeStep: step }, { productionPaddingXmm, productionPaddingYmm }); }
        catch { return { ok: false }; }
      }
      const sizeIsAvailable = artwork => artwork.ok && (!custom || !fitFor(artwork).clamped) &&
        (!artwork.iconCount || artwork.iconHeightMm * scaleFor(artwork) >= 20 - 0.001) && artwork.textHeightMM * scaleFor(artwork) >= 20 - 0.001;
      while (item.iconSizeStep !== 0 && !sizeIsAvailable(result)) {
        const next = item.iconSizeStep + (item.iconSizeStep < 0 ? 1 : -1);
        result = candidateFor(next);
        item.iconSizeStep = next;
        field('iconSize').value = String(item.iconSizeStep);
      }
      syncIconSizeAdjustment();
      for (const button of root.querySelectorAll('[data-ss-icon-size-step]')) {
        const next = item.iconSizeStep + Number(button.dataset.ssIconSizeStep);
        if (!button.disabled) button.disabled = noIcon || !sizeIsAvailable(candidateFor(next));
      }
      const fitted = custom ? fitFor(result) : null;
      if (fitted?.ok) {
        minimumDimensions = fitted.minimum;
        if (fitted.clamped) {
          requestedCm = fitted.targetMm / 10;
          if (commitSizeInput || document.activeElement !== field(`${requestedAxis}Cm`))
            field(`${requestedAxis}Cm`).value = String(requestedCm);
          sizeNotice = 'This is the smallest this design can go.';
        }
      }
      const scale = fitted ? fitted.scale : scaleFor(result);
      if (!Number.isFinite(scale)) { showWarning('This heading cannot fit. Try a larger size.'); return; }
      const headed = headingEnabled ? headedArtwork(result, scale, item.heading, productionPaddingXmm, productionPaddingYmm) : null;
      if (headingEnabled && !headed?.ok) { showWarning(designError(headed?.error || 'Heading preview is unavailable.')); return; }
      if (headed) {
        lastMainWidthMm = headed.mainBounds.w / D.MM;
        lastHeadingHeightMm = headed.headingHeightMm;
        item.heading.sizeMm = headed.headingHeightMm;
        field('headingSizeCm').placeholder = `${cmInput(headed.headingHeightMm)} Auto`;
        if (headingSizeRatio !== null && document.activeElement !== field('headingSizeCm'))
          field('headingSizeCm').value = cmInput(headed.headingHeightMm);
        const smaller = root.querySelector('[data-ss-heading-size-step="-1"]');
        smaller.disabled = headed.headingHeightMm <= 20 + 0.001;
        root.querySelector('[data-ss-heading-size-step="1"]').disabled = headed.headingHeightMm >= 570 - 0.001;
      }
      const stickerWidthMm = headed ? headed.artworkWidthMm : result.artworkWidthMm * scale;
      const stickerHeightMm = headed ? headed.artworkHeightMm : result.artworkHeightMm * scale;
      if (!headingEnabled) out('heading-button-note').hidden = stickerWidthMm >= 300 - 0.001 && (custom || size.width >= 300);
      const productionWidthMm = stickerWidthMm + 2 * productionPaddingXmm;
      const productionHeightMm = stickerHeightMm + 2 * productionPaddingYmm;
      const longCm = Math.max(stickerWidthMm, stickerHeightMm) / 10;
      const shortCm = Math.min(stickerWidthMm, stickerHeightMm) / 10;
      const addOns = updateAddOns(size, stickerWidthMm, stickerHeightMm, qty);
      if (!custom || sizingMode !== 'width') field('widthCm').value = cmInput(stickerWidthMm);
      if (!custom || sizingMode !== 'height') field('heightCm').value = cmInput(stickerHeightMm);
      field('widthCm').step = sizingMode === 'width' ? '0.5' : 'any';
      field('heightCm').step = sizingMode === 'height' ? '0.5' : 'any';
      for (const button of root.querySelectorAll('[data-ss-size-axis]')) {
        const amount = Number(field(`${button.dataset.ssSizeAxis}Cm`).value);
        const limit = Number(button.dataset.ssSizeStep) < 0 ? (custom ? Math.ceil((minimumDimensions[`${button.dataset.ssSizeAxis}Mm`] - 1e-8) * 10) / 100 : button.dataset.ssSizeAxis === 'width' ? 4 : 2) : 150;
        button.disabled = Number(button.dataset.ssSizeStep) < 0 ? amount <= limit + 0.001 : amount >= limit - 0.001;
      }
      for (const button of root.querySelectorAll('[data-ss-qty-step]'))
        button.disabled = Number(button.dataset.ssQtyStep) < 0 ? qty <= 1 : qty >= 10000;
      if (Number.isFinite(stickerWidthMm) && Number.isFinite(stickerHeightMm) && stickerWidthMm > 0 && stickerHeightMm > 0 && Math.max(stickerWidthMm, stickerHeightMm) <= 3000) {
        out('art').append(artworkSvg(headed || result, stickerWidthMm, stickerHeightMm, productionWidthMm, headed ? 1 : scale, colour, item.inverse, productionPaddingXmm, productionPaddingYmm));
        out('width-label').textContent = cm(stickerWidthMm);
        out('height-label').textContent = cm(stickerHeightMm);
        out('mobile-size-label').textContent = `${cm(stickerWidthMm)} × ${cm(stickerHeightMm)}`;
        out('ruler-x').setAttribute('aria-label', `Length ${cm(stickerWidthMm)}, height ${cm(stickerHeightMm)}`);
        out('ruler-y').setAttribute('aria-label', `Height ${cm(stickerHeightMm)}`);
        out('assembly').hidden = false;
        previewDimensions = { width: stickerWidthMm, height: stickerHeightMm };
        sizePreview();
        out('size').textContent = `${size.label} · ${colour.label}${item.inverse ? ' · Inside Glass' : ''}`;
      }
      if ((result.iconCount && result.iconHeightMm * scale < 20 - 0.001) || result.textHeightMM * scale < 20 - 0.001) {
        showWarning('The height is too small. Pick a larger size or a different font.'); return;
      }
      if (headingEnabled && headed.headingHeightMm < 20 - 0.001) { showWarning('Heading is too small. Min 2 cm.'); return; }
      if (headingEnabled && custom && Math.abs((sizingMode === 'height' ? stickerHeightMm : stickerWidthMm) - requestedCm * 10) > 0.01) {
        showWarning(`The heading needs more ${requestedLabel}. Choose a larger size.`); return;
      }
      if (stickerWidthMm > 1500.001) { showWarning('Selected length is too big. Max 150 cm.'); return; }
      if (stickerHeightMm > 1500.001) { showWarning('Selected height is too big. Max 150 cm.'); return; }
      if (headingEnabled && stickerWidthMm < 300 - 0.001) { resetHeadingControls(); render(); return; }
      if (headingEnabled && !custom && size.width && stickerWidthMm > size.width + 0.001) {
        showWarning('Heading is too long for this size. Choose a larger size.'); return;
      }
      if (standard && stickerWidthMm > 230.001) { showWarning('Too long for Standard Decal. Max 23 cm.'); return; }
      if (standard && !headingEnabled && stickerHeightMm > 30.001) { showWarning('Too tall for Standard Decal. Max 3 cm.'); return; }
      if (largerDecal && stickerWidthMm > 260.001) { showWarning('Too long for Larger Decal. Max 26 cm.'); return; }
      if (largerDecal && !headingEnabled && stickerHeightMm > 50.001) { showWarning('Too tall for Larger Decal. Max 5 cm.'); return; }
      if (shortCm > 57.0001) { showWarning('One side must be 57 cm or less.'); return; }
      if (stickerWidthMm < 40 - 0.0001) { showWarning('Length is too small. Min 4 cm.'); return; }
      if (stickerHeightMm < 20 - 0.0001) { showWarning('Height is too small. Min 2 cm.'); return; }
      const variant = custom ? null : variantFor(config, size.label, material);
      out('price').textContent = iconCount === 1 && variant && Number.isFinite(Number(variant.price)) && Number.isInteger(qty) && qty > 0 ? money(Number(variant.price) * qty) : '...';
      const baseMaterialWidthMm = Number(config.baseMaterialWidthMm) || 280;
      if (sizeNotice) showWarning(sizeNotice);
      if (result.warnings.length) showWarning(result.warnings[0]);
      if (!Number.isInteger(qty) || qty < 1 || qty > 10000) { showWarning('Enter a quantity from 1 to 10,000.'); return; }
      if (config.pricingPreviewEnabled && !window.SSPricingTest) { showWarning('Price unavailable. Reload the page.'); return; }
      if (config.pricingPreviewEnabled && window.SSPricingTest) {
        const trial = window.SSPricingTest.quote({
          widthCm: stickerWidthMm / 10,
          heightCm: stickerHeightMm / 10,
          colour: colour.label,
          quantity: qty,
          iconCount,
          standard,
          largerDecal,
          heading: headingEnabled,
        });
        if (!trial.ok) {
          showWarning(/production space/i.test(trial.error) ? 'This size does not fit our material.' : trial.error);
          return;
        }
        renderTierPrices(trial.unitListPrice);
        const bundleDiscountPercent = discountFor(eligibleBundleQuantity(qty));
        const discountedUnitCents = Math.round(Math.round(trial.unitListPrice * 100) * (100 - bundleDiscountPercent) / 100);
        const lineCents = discountedUnitCents * qty;
        const unitDetail = `${money(discountedUnitCents)} Each`;
        showPrice(lineCents, Math.round(trial.unitListPrice * 100) * qty, bundleDiscountPercent
          ? `${unitDetail} after ${bundleDiscountPercent}% off (was ${money(Math.round(trial.unitListPrice * 100))}).`
          : `${unitDetail}.`);
        if (config.checkoutEnabled) {
          const pricedVariant = Order.variantForBand(config, trial, size);
          if (!pricedVariant || !pricedVariant.available) {
            updateFreeShipping();
            showWarning('This design is not ready to order.');
            return;
          }
          if (Number(pricedVariant.price) !== Math.round(trial.unitListPrice * 100)) {
            updateFreeShipping();
            showWarning('This price needs a check before ordering.');
            return;
          }
          if (trial.route.provisional) {
            updateFreeShipping();
            showWarning('This colour and size need a stock check.');
            return;
          }
          current = { item, colour: colour.label, material, size, sizingMode: custom ? sizingMode : 'preset length', stickerWidthMm, stickerHeightMm, productionWidthMm, productionHeightMm, mainArtworkWidthMm: headed?.mainArtworkWidthMm, mainArtworkHeightMm: headed?.mainArtworkHeightMm, bandId: trial.route.bandId, variant: pricedVariant, qty, addOns };
          syncPurchaseButtons();
        }
        return;
      }
      if (productionWidthMm > baseMaterialWidthMm) {
        showWarning('This size needs a custom quote.');
        out('price').textContent = '...';
        return;
      }
      if (custom) {
        showWarning('This custom size needs a quote.');
        return;
      }
      if (iconCount > 1) {
        showWarning('This multi-icon decal needs a quote.');
        return;
      }
      if (!variant || variant.available === false) {
        showWarning('This size and colour need a quote.');
        return;
      }
      if (!config.checkoutEnabled) {
        showWarning('Ordering is not available in this preview.');
        return;
      }
      current = { item, colour: colour.label, material, size, sizingMode: custom ? sizingMode : 'preset length', stickerWidthMm, stickerHeightMm, productionWidthMm, productionHeightMm, variant, qty, addOns };
      syncPurchaseButtons();
    }

    root.addEventListener('input', event => {
      if (!event.target.matches('input,select')) return;
      sizeNotice = '';
      if (event.target === field('widthCm')) sizingMode = 'width';
      if (event.target === field('heightCm')) sizingMode = 'height';
      if (event.target === field('headingSizeCm')) {
        const typed = event.target.value;
        if (typed === '') headingSizeRatio = null;
        else if (Number.isFinite(Number(typed)) && lastMainWidthMm > 0) {
          headingSizeRatio = Math.max(2, Number(typed)) * 10 / lastMainWidthMm;
          if (Number(typed) < 2) sizeNotice = 'This is the smallest this design can go.';
        }
      }
      if (event.target === field('widthCm') || event.target === field('heightCm') || event.target === field('sizeChoice')) headingAutoSized = false;
      current = null;
      for (const button of root.querySelectorAll('[data-ss-purchase]')) button.disabled = true;
      out('cart-message').textContent = '';
      clearTimeout(timer);
      timer = setTimeout(render, 90);
    });
    root.addEventListener('focusin', event => {
      if (event.target === field('widthCm') || event.target === field('heightCm')) {
        focusedSizeValue = event.target.value;
        event.target.step = '0.5';
        field(event.target === field('widthCm') ? 'heightCm' : 'widthCm').step = 'any';
      }
    });
    root.addEventListener('focusout', event => {
      if (event.target !== field('widthCm') && event.target !== field('heightCm')) return;
      if (event.target.value === focusedSizeValue) { focusedSizeValue = null; return; }
      focusedSizeValue = null;
      const value = Number(event.target.value);
      if (Number.isFinite(value) && value >= (event.target === field('widthCm') ? 4 : 2) && value <= 150 && !sizeNotice) event.target.value = String(Math.round(value * 2) / 2);
      sizingMode = event.target === field('widthCm') ? 'width' : 'height';
      clearTimeout(timer);
      render(true);
    });
    root.addEventListener('change', event => {
      if (event.target === field('headingSizeCm') && event.target.value !== '' && Number(event.target.value) < 2) {
        event.target.value = '2';
        if (lastMainWidthMm > 0) headingSizeRatio = 20 / lastMainWidthMm;
        sizeNotice = 'This is the smallest this design can go.';
      }
      if (event.target === field('headingPreset') && event.target.value === 'custom' && !field('headingCustom').value.trim()) field('headingCustom').value = 'Custom Text';
      if (event.target === field('platform')) renderIcons('platform', 'icon');
      if (event.target === field('secondPlatform')) {
        renderIcons('secondPlatform', 'secondIcon');
        updateSecondIconButton();
      }
      if (event.target === field('thirdPlatform')) renderIcons('thirdPlatform', 'thirdIcon');
      if (event.target === field('sizeChoice')) sizingMode = 'width';
      if (event.target === field('sizeChoice') || event.target === field('widthCm') || event.target === field('heightCm')) headingAutoSized = false;
      if (event.target === field('widthCm') || event.target === field('heightCm')) {
        const value = Number(event.target.value);
        if (Number.isFinite(value) && value >= (event.target === field('widthCm') ? 4 : 2) && value <= 150 && !sizeNotice) event.target.value = String(Math.round(value * 2) / 2);
      }
      clearTimeout(timer);
      render(true);
    });
    root.addEventListener('click', event => {
      const headingArrowChoice = event.target.closest('[data-ss-heading-arrow-choice]');
      if (headingArrowChoice) {
        field('headingArrowStyle').value = headingArrowChoice.dataset.ssHeadingArrowChoice;
        current = null;
        out('cart-message').textContent = '';
        render();
        return;
      }
      const quantityStep = event.target.closest('[data-ss-qty-step]');
      if (quantityStep) {
        const qty = Number(field('qty').value);
        const next = Math.min(10000, Math.max(1, (Number.isInteger(qty) ? qty : 1) + Number(quantityStep.dataset.ssQtyStep)));
        field('qty').value = String(next);
        current = null;
        out('cart-message').textContent = '';
        render();
        return;
      }
      const adjustButton = event.target.closest('[data-ss-adjust]');
      if (adjustButton) {
        const name = adjustButton.dataset.ssAdjust;
        const setting = { spacing: { min: 0, max: 5, step: 1 }, iconPosition: { min: -3, max: 3, step: 0.5 } }[name];
        const control = field(name);
        control.value = String(Math.min(setting.max, Math.max(setting.min, Number(control.value) + Number(adjustButton.dataset.ssDirection) * setting.step)));
        current = null;
        out('cart-message').textContent = '';
        render();
        return;
      }
      const iconSizeButton = event.target.closest('[data-ss-icon-size-step]');
      if (iconSizeButton) {
        const next = Number(field('iconSize').value) + Number(iconSizeButton.dataset.ssIconSizeStep);
        field('iconSize').value = String(Math.min(3, Math.max(-3, next)));
        current = null;
        out('cart-message').textContent = '';
        render();
        return;
      }
      const sizeStepButton = event.target.closest('[data-ss-size-axis]');
      if (sizeStepButton) {
        sizeNotice = '';
        const axis = sizeStepButton.dataset.ssSizeAxis;
        const control = field(`${axis}Cm`);
        const direction = Number(sizeStepButton.dataset.ssSizeStep);
        const currentCm = Number(control.value);
        control.value = String(Math.min(150, Math.max(axis === 'width' ? 4 : 2, nextHalfCm(currentCm, direction))));
        sizingMode = axis;
        headingAutoSized = false;
        current = null;
        out('cart-message').textContent = '';
        render();
        return;
      }
      const headingSizeButton = event.target.closest('[data-ss-heading-size-step]');
      if (headingSizeButton) {
        const input = field('headingSizeCm');
        const currentCm = (lastHeadingHeightMm ?? 20) / 10;
        const next = nextHalfCm(currentCm, Number(headingSizeButton.dataset.ssHeadingSizeStep));
        input.value = String(Math.min(57, Math.max(2, next)));
        if (lastMainWidthMm > 0) headingSizeRatio = Number(input.value) * 10 / lastMainWidthMm;
        current = null;
        out('cart-message').textContent = '';
        render();
        return;
      }
      const headingGapButton = event.target.closest('[data-ss-heading-gap-step]');
      if (headingGapButton) {
        const next = Number(field('headingGap').value) + Number(headingGapButton.dataset.ssHeadingGapStep);
        field('headingGap').value = String(Math.min(15, Math.max(5, next)));
        current = null;
        out('cart-message').textContent = '';
        render();
        return;
      }
      const addOnButton = event.target.closest('[data-ss-addon-button]');
      if (addOnButton) {
        const kind = addOnButton.dataset.ssAddonButton;
        if (kind === 'squeegee' && (!squeegeeCartReady || squeegeeInCart)) return;
        if (kind === 'backing' && !field('backing').checked) {
          const qty = Number(field('qty').value);
          if (!Number.isInteger(qty) || qty < 1 || qty > 10000) {
            showWarning('Enter a quantity from 1 to 10,000.');
            field('qty').focus();
            return;
          }
        }
        field(kind).checked = !field(kind).checked;
        syncAddOnButtons();
        render();
        return;
      }
      if (event.target.closest('[data-ss-colour-toggle]')) {
        const expanded = root.dataset.ssColoursExpanded !== 'true';
        root.dataset.ssColoursExpanded = String(expanded);
        updateColourToggle();
        return;
      }
      const colourButton = event.target.closest('[data-ss-colour-choice]');
      if (colourButton) {
        field('colour').value = colourButton.dataset.ssColourChoice;
        field('colour').dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      const iconButton = event.target.closest('[data-ss-icon-choice]');
      if (iconButton) {
        const select = field(iconButton.dataset.ssIconTarget);
        select.value = iconButton.dataset.ssIconChoice;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      const fontButton = event.target.closest('[data-ss-font-choice]');
      if (fontButton) {
        field('font').value = fontButton.dataset.ssFontChoice;
        setFontMenuOpen(false);
        field('font').dispatchEvent(new Event('change', { bubbles: true }));
        out('font-trigger').focus();
        return;
      }
      const headingFontButton = event.target.closest('[data-ss-heading-font-choice]');
      if (headingFontButton) {
        field('headingFont').value = headingFontButton.dataset.ssHeadingFontChoice;
        setHeadingFontMenuOpen(false);
        field('headingFont').dispatchEvent(new Event('change', { bubbles: true }));
        out('heading-font-trigger').focus();
        return;
      }
      if (event.target.closest('[data-ss-font-trigger]')) setFontMenuOpen(out('font-menu').hidden);
      if (event.target.closest('[data-ss-heading-font-trigger]')) setHeadingFontMenuOpen(out('heading-font-menu').hidden);
    });
    root.addEventListener('keydown', event => {
      const headingPicker = Boolean(event.target.closest('[data-ss-heading-font-trigger], [data-ss-heading-font-menu]'));
      const menu = headingPicker ? out('heading-font-menu') : out('font-menu');
      if (event.key === 'Escape' && !menu.hidden) {
        if (headingPicker) { setHeadingFontMenuOpen(false); out('heading-font-trigger').focus(); }
        else { setFontMenuOpen(false); out('font-trigger').focus(); }
        return;
      }
      if (!event.target.closest('[data-ss-font-trigger], [data-ss-font-menu], [data-ss-heading-font-trigger], [data-ss-heading-font-menu]')) return;
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      event.preventDefault();
      if (menu.hidden) headingPicker ? setHeadingFontMenuOpen(true) : setFontMenuOpen(true);
      const attr = headingPicker ? 'ssHeadingFontChoice' : 'ssFontChoice';
      const buttons = [...menu.querySelectorAll(headingPicker ? '[data-ss-heading-font-choice]' : '[data-ss-font-choice]')];
      const currentIndex = buttons.indexOf(document.activeElement);
      const selectedIndex = buttons.findIndex(button => button.dataset[attr] === field(headingPicker ? 'headingFont' : 'font').value);
      const nextIndex = currentIndex < 0 ? selectedIndex : (currentIndex + (event.key === 'ArrowDown' ? 1 : -1) + buttons.length) % buttons.length;
      buttons[nextIndex]?.focus();
    });
    document.addEventListener('click', event => {
      if (!event.target.closest('.ss-font-picker')) setFontMenuOpen(false);
      if (!event.target.closest('.ss-font-picker')) setHeadingFontMenuOpen(false);
    });
    function syncFirstIcon() {
      out('first-icon-panel').hidden = noIcon;
      out('add-first-icon').hidden = !noIcon;
      root.querySelector('.ss-icon-size-adjust').hidden = noIcon;
      field('iconPosition').closest('.ss-adjust').hidden = noIcon;
    }
    out('remove-first-icon').addEventListener('click', () => {
      if (field('secondPlatform').value) {
        field('platform').value = field('secondPlatform').value;
        renderIcons('platform', 'icon');
        field('icon').value = field('secondIcon').value;
        renderIconPicker('platform', 'icon');
        field('secondPlatform').value = field('thirdPlatform').value;
        renderIcons('secondPlatform', 'secondIcon');
        if (field('thirdPlatform').value) field('secondIcon').value = field('thirdIcon').value;
        renderIconPicker('secondPlatform', 'secondIcon');
        field('thirdPlatform').value = '';
        renderIcons('thirdPlatform', 'thirdIcon');
        out('second-icon-panel').hidden = !field('secondPlatform').value;
        out('third-icon-panel').hidden = true;
      } else {
        noIcon = true;
        field('iconSize').value = '0';
        field('iconPosition').value = '0';
      }
      syncFirstIcon();
      updateSecondIconButton();
      render();
      (noIcon ? out('add-first-icon') : out('remove-first-icon')).focus();
    });
    out('add-first-icon').addEventListener('click', () => {
      noIcon = false;
      syncFirstIcon();
      render();
      field('platform').focus();
    });
    out('icon-toggle').addEventListener('click', () => {
      field('secondPlatform').value = 'FACEBOOK';
      renderIcons('secondPlatform', 'secondIcon');
      field('secondIcon').value = '2';
      renderIconPicker('secondPlatform', 'secondIcon');
      out('second-icon-panel').hidden = false;
      updateSecondIconButton();
      render();
      field('secondPlatform').focus();
    });
    out('heading-toggle').addEventListener('click', () => {
      if (!out('heading-panel').hidden) { field('headingPreset').focus(); return; }
      clearTimeout(timer);
      render();
      const size = SIZE_CHOICES.find(choice => choice.label === field('sizeChoice').value);
      const lengthMm = previewDimensions?.width ?? (size.width === null ? Number(field('widthCm').value) * 10 : size.width);
      const undersizedPreset = size.width !== null && size.width < 300;
      headingAutoSized = undersizedPreset || !Number.isFinite(lengthMm) || lengthMm < 300 - 0.001;
      if (headingAutoSized) {
        field('sizeChoice').value = 'Custom Size';
        field('widthCm').value = '30';
        sizingMode = 'width';
      }
      out('heading-panel').hidden = false;
      out('heading-toggle').setAttribute('aria-expanded', 'true');
      render();
      field('headingPreset').focus();
    });
    document.addEventListener('click', event => {
      const idea = event.target.closest('[data-ss-heading-idea]');
      if (!idea) return;
      const text = idea.dataset.ssHeadingIdea.replace(/[\u2018\u2019]/g, "'");
      if (text.length > 40) return;
      if (out('heading-panel').hidden) out('heading-toggle').click();
      field('headingPreset').value = 'custom';
      field('headingCustom').value = text;
      render();
      out('heading-panel').scrollIntoView({ behavior: 'smooth', block: 'center' });
      field('headingCustom').focus({ preventScroll: true });
    });
    out('remove-heading').addEventListener('click', () => {
      resetHeadingControls();
      render();
      out('heading-toggle').focus();
    });
    out('remove-icon').addEventListener('click', () => {
      field('thirdPlatform').value = '';
      renderIcons('thirdPlatform', 'thirdIcon');
      out('third-icon-panel').hidden = true;
      field('secondPlatform').value = '';
      renderIcons('secondPlatform', 'secondIcon');
      out('second-icon-panel').hidden = true;
      updateSecondIconButton();
      render();
      out('icon-toggle').focus();
    });
    out('third-icon-toggle').addEventListener('click', () => {
      field('thirdPlatform').value = 'TIKTOK';
      renderIcons('thirdPlatform', 'thirdIcon');
      out('third-icon-panel').hidden = false;
      updateSecondIconButton();
      render();
      field('thirdPlatform').focus();
    });
    out('remove-third-icon').addEventListener('click', () => {
      field('thirdPlatform').value = '';
      renderIcons('thirdPlatform', 'thirdIcon');
      out('third-icon-panel').hidden = true;
      updateSecondIconButton();
      render();
      out('third-icon-toggle').focus();
    });
    function setAdvancedOpen(open) {
      out('advanced-panel').hidden = !open;
      out('advanced-toggle').hidden = open;
      out('advanced-toggle').setAttribute('aria-expanded', String(open));
    }
    out('advanced-toggle').addEventListener('click', () => {
      setAdvancedOpen(true);
      field('upper').focus();
    });
    out('close-advanced').addEventListener('click', () => {
      setAdvancedOpen(false);
      out('advanced-toggle').focus();
    });
    out('reset-advanced').addEventListener('click', () => {
      field('spacing').value = '0';
      field('iconPosition').value = '0';
      field('upper').checked = false;
      field('inverse').checked = false;
      field('headingSizeStep').value = '0';
      field('headingSizeCm').value = '';
      headingSizeRatio = null;
      field('headingGap').value = '10';
      current = null;
      out('cart-message').textContent = '';
      render();
    });
    for (const button of root.querySelectorAll('[data-ss-tier]')) {
      button.addEventListener('click', () => {
        field('qty').value = button.dataset.ssTier;
        render();
      });
    }
    root.querySelectorAll('[data-ss-purchase]').forEach(button => button.addEventListener('click', async () => {
      if (!current || adding) return;
      const checkoutNow = button.dataset.ssPurchase === 'checkout';
      const { item, colour, material, size, sizingMode, stickerWidthMm, stickerHeightMm, productionWidthMm, productionHeightMm, mainArtworkWidthMm, mainArtworkHeightMm, bandId, variant, qty, addOns } = current;
      const productionProps = {
        Username: item.username.trim(),
        Font: `Font ${item.font}`,
        'Use Capitals': item.upper ? 'Yes' : 'No',
        'Icon Size': item.iconSizeStep < 0 ? `Smaller ${-item.iconSizeStep}` : item.iconSizeStep > 0 ? `Larger ${item.iconSizeStep}` : 'Match Text',
        Spacing: String(item.spacingStep),
        ...(D.bettyCapitalSpacingPercent(item, item.upper ? item.username.trim().toUpperCase() : item.username.trim())
          ? { '_Betty Capital Spacing Percent': String(D.bettyCapitalSpacingPercent(item, item.upper ? item.username.trim().toUpperCase() : item.username.trim())), '_Betty Spacing Version': '2' }
          : {}),
        'Icon Position': item.iconYOffsetMm < 0 ? `Up ${-item.iconYOffsetMm}` : item.iconYOffsetMm > 0 ? `Down ${item.iconYOffsetMm}` : 'Centre',
        Platform: item.noIcon ? 'None' : D.PLATFORMS.find(p => p.key === item.platform).label,
        ...(item.noIcon ? { 'Artwork Type': 'Text Only' } : {}),
        Style: item.noIcon ? 'None' : `Icon ${item.icon}`,
        'Icon Count': String(Number(!item.noIcon) + Number(Boolean(item.secondPlatform)) + Number(Boolean(item.thirdPlatform))),
        Colour: colour,
        Material: material === 'Specialty vinyl' ? 'Speciality Vinyl' : 'Gloss Vinyl',
        'Decal Size': size.label,
        'Size Set By': sizingMode === 'width' ? 'Length' : sizingMode === 'height' ? 'Height' : 'Preset Length',
        'Sticker Artwork': `${cm(stickerHeightMm)} high × ${cm(stickerWidthMm)} long`,
        'Production Space': `${cm(productionHeightMm)} high × ${cm(productionWidthMm)} long`,
        Installation: item.inverse ? 'Inside Glass (Mirrored)' : 'Outside Surface',
        '_Font engine ID': String(item.font),
        '_Decal engine': item.heading ? 'storefront-v0.2-heading' : 'storefront-v0.1',
        ...Order.measurementProperties({ stickerWidthMm, stickerHeightMm, productionWidthMm, productionHeightMm }, window.SSPricingTest.PRICING_VERSION),
        '_Shipping class': Order.shippingClass({ sizeLabel: size.label, productionWidthCm: productionWidthMm / 10, productionHeightCm: productionHeightMm / 10 }),
      };
      if (bandId) productionProps['_Production band'] = bandId;
      if (item.heading) Object.assign(productionProps, {
        '_Heading Text': item.heading.text.trim(),
        '_Heading Font': String(item.heading.font),
        '_Heading Font Choice': String(item.heading.fontChoice),
        '_Heading Size Step': String(item.heading.sizeStep),
        ...(item.heading.sizeMm === null ? {} : { '_Heading Size Mm': String(item.heading.sizeMm) }),
        ...(item.heading.sizeRatio === null ? {} : { '_Heading Size Ratio': String(item.heading.sizeRatio) }),
        '_Heading Alignment': item.heading.align,
        '_Heading Arrow': item.heading.arrow ? 'Yes' : 'No',
        '_Heading Arrow Style': item.heading.arrowStyle,
        '_Heading Gap Mm': String(item.heading.gapMm),
        '_Main Artwork Width Cm': String(mainArtworkWidthMm / 10),
        '_Main Artwork Height Cm': String(mainArtworkHeightMm / 10),
      });
      if (item.secondPlatform) {
        productionProps['Second Platform'] = D.PLATFORMS.find(p => p.key === item.secondPlatform).label;
        productionProps['Second Style'] = `Icon ${item.secondIcon}`;
      }
      if (item.thirdPlatform) {
        productionProps['Third Platform'] = D.PLATFORMS.find(p => p.key === item.thirdPlatform).label;
        productionProps['Third Style'] = `Icon ${item.thirdIcon}`;
      }
      const artworkSize = `${cmNumber(stickerWidthMm)} × ${cmNumber(stickerHeightMm)} cm`;
      const iconSummary = [
        item.noIcon ? null : `${productionProps.Platform} ${item.icon}`,
        item.secondPlatform ? `${productionProps['Second Platform']} ${item.secondIcon}` : null,
        item.thirdPlatform ? `${productionProps['Third Platform']} ${item.thirdIcon}` : null,
      ].filter(Boolean).join(' · ');
      const props = {
        Design: `${item.upper ? productionProps.Username.toUpperCase() : productionProps.Username} · ${colour} · ${artworkSize}`,
        Details: [`Font ${item.font}`, iconSummary].filter(Boolean).join(' · '),
        ...(item.heading ? { Heading: item.heading.text.trim() } : {}),
      };
      for (const [key, value] of Object.entries(productionProps)) {
        props[key.startsWith('_') ? key : `_${key}`] = value;
      }
      const items = [{ id: Number(variant.id), quantity: qty, properties: props }, ...addOns.map(addOn => ({ id: addOn.id, quantity: addOn.quantity }))];
      const signature = Order.decalSignature(items[0]);
      const route = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (!checkoutNow && Date.now() < addCooldownUntil && signature === addedSignature) return;
      adding = true;
      syncPurchaseButtons();
      out('cart-message').textContent = 'Adding your decal...';
      try {
        let pendingItems = items;
        if (checkoutNow && signature === addedSignature) {
          // The add-on controls clear after a successful addition. Reuse the same decal
          // after checking that it is still in the cart, including after the toast closes.
          const cartResponse = await fetch(route + 'cart.js');
          if (!cartResponse.ok) throw new Error('Could not check your cart. Please try again.');
          const cart = await cartResponse.json();
          updateCartState(cart);
          pendingItems = Order.checkoutItems(items, addedSignature, cart);
          if (squeegeeInCart) pendingItems = pendingItems.filter(line => line.id !== ADD_ONS.squeegee.variants[0].id);
          if (pendingItems.length === 0) { window.location.assign(route + 'checkout'); return; }
        }
        const response = await fetch(route + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: pendingItems }),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Could not add this decal.');
        addedSignature = signature;
        addCooldownUntil = Date.now() + 3500;
        if (addOns.some(addOn => addOn.id === ADD_ONS.squeegee.variants[0].id)) squeegeeInCart = true;
        field('squeegee').checked = false;
        field('backing').checked = false;
        render();
        if (checkoutNow) {
          window.location.assign(route + 'checkout');
          return;
        }
        showCartToast(qty);
        const message = out('cart-message');
        message.textContent = '';
        const cartLink = document.createElement('a');
        cartLink.href = route + 'cart';
        cartLink.textContent = 'View Cart';
        message.appendChild(cartLink);
        message.append(' to check your final discounts.');
        try {
          const cartResponse = await fetch(route + 'cart.js');
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            updateCartState(cart);
            syncAddOnButtons();
            document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
          }
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } catch (_) {
          // The cart page remains available if the theme's badge cannot refresh.
        }
        window.dispatchEvent(new CustomEvent('ss:cart-updated', { detail: data }));
      } catch (error) {
        out('cart-message').textContent = error.message;
      } finally {
        adding = false;
        syncPurchaseButtons();
        setTimeout(syncPurchaseButtons, Math.max(0, addCooldownUntil - Date.now()) + 10);
      }
    }));
    renderIcons('platform', 'icon');
    renderIcons('secondPlatform', 'secondIcon');
    renderIcons('thirdPlatform', 'thirdIcon');
    updateSecondIconButton();
    render();
    checkSqueegeeInCart();
  }

  document.querySelectorAll('[data-ss-designer]').forEach(mount);
})();
